import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Index from '@/components/dashboard/Index'
import IndexBoard from '@/views/dsms/Overview.vue'
import LeadsDashboard from '@/components/dashboard/LeadsDashboard'
import ProjectsDashboard from '@/components/dashboard/ProjectsDashboard'
import Blankpage from '@/components/page/Blankpage'
import Companies from '@/components/company/Companies'
import Components from '@/components/component/Components'
import Datatables from '@/components/tables/Datatables'
import Deals from '@/components/deals/Deals'
import Email from '@/components/mail/Email'
import Error404 from '@/components/error/Error404'
import Error500 from '@/components/error/Error500'
import Faq from '@/components/page/Faq'
import FormBasicInputs from '@/components/form/FormBasicInputs'
import FormHorizontal from '@/components/form/FormHorizontal'
import FormInputGroups from '@/components/form/FormInputGroups'
import FormMask from '@/components/form/FormMask'
import FormValidation from '@/components/form/FormValidation'
import FormVertical from '@/components/form/FormVertical'
import Login from '@/components/page/Login'
import Goto from '@/components/page/GotoNext.vue'
import SelectMandant from '@/components/page/SelectMandant'
import MailView from '@/components/mail/MailView'
import PrivacyPolicy from '@/components/page/PrivacyPolicy'
import Profile from '@/components/page/Profile'
import Register from '@/components/page/Register'
import ProjectsKanbanView from '@/components/projects/ProjectsKanbanView'
import Projects from '@/components/projects/Projects'
import Reports from '@/views/dsms/Overview.vue'
import Settings from '@/components/page/Settings'
import TablesBasic from '@/components/tables/TablesBasic'
import Tasks from '@/components/page/Tasks'
import Terms from '@/components/page/Terms'
import Survey from '@/views/survey_samples/Survey'
import TestGap from '@/views/account/TestGap'
import EditGap from '@/views/account/EditGap'
import TomsContent from '@/views/toms/TomsContent'
import TomsEdit from '@/views/toms/TomsEdit'
import TomsList from '@/views/toms/TomsList.vue'
import ConfirmToms from '@/views/toms/ConfirmToms.vue'
import CustomerInfo from '@/views/avcheck/CustomerInfo'
import SurveyContent from '@/views/avcheck/SurveyContent'
import AvvEdit from '@/views/avcheck/AvvEdit'
import AvvList from '@/views/avcheck/AvvList'
import ConfirmAV from '@/views/avcheck/ConfirmAV'
import VTs from '@/views/dsms/VTs'
import VTSelbst from '@/views/dsms/VTSelbst'
import System from '@/views/dsms/System'
import SystemAssessmentList from '@/views/dsms/SystemAssessmentList.vue'
import Supplier from '@/views/dsms/Supplier'
import Massnahmen from '@/views/dsms/Massnahmen'
import AIMassnahmen from '@/views/dsms/AIMassnahmen'
import MassnahmenCalendarView from '@/views/dsms/MassnahmenCalendarView.vue'
import GapList from '@/views/dsms/GapList'
import AIGapList from '@/views/dsms/AIGapList'
import Audit from '@/views/dsms/Audit.vue'
import AuditPlan from '@/views/dsms/AuditPlan'
import SurveyPreview from '@/views/avcheck/SurveyPreview'
import Incident from '@/views/dsms/Incident.vue'
import SharedResponsibility from '@/views/dsms/SharedResponsibility.vue'
import GenerateDSReport from '@/views/dsms/GenerateDSReport.vue'
import RiskAnalysis from "@/views/dsms/RiskAnalysis.vue";
import ChatBot from "@/views/dsms/ChatBot.vue";
import AIChatBot from "@/views/dsms/AIChatBot.vue";
import CustomerInfoDemo from '@/views/avcheck/CustomerInfoAI.vue';
import CreateWebsiteAudit from '@/views/website_audit/CreateWebsiteAudit.vue';
import WebsiteAudit from '@/views/website_audit/WebsiteAudit.vue';

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: 'template/light',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Login,
      props: true
    },
    {
      path: '/select-mandant',
      name: 'select-mandant',
      component: SelectMandant
    },
    {
      path: '/index',
      name: 'indexx',
      component: IndexBoard
    },
    {
      path: '/leads-dashboard',
      name: 'leads-dashboard',
      component: LeadsDashboard
    },
    {
      path: '/report-standard',
      name: 'report-standard',
      component: LeadsDashboard
    },
    {
      path: '/report-gap',
      name: 'report-gap',
      component: LeadsDashboard
    },
    {
      path: '/report-massnahmen',
      name: 'report-massnahmen',
      component: LeadsDashboard
    },
    {
      path: '/massnahmenplan',
      name: 'massnahmenplan',
      component: Massnahmen,
      props: true
    },
    {
      path: '/ai-massnahmenplan',
      name: 'ai-massnahmenplan',
      component: AIMassnahmen,
      props: true
    },
    {
      path: '/massnahmenplan-calendar-view',
      name: 'massnahmenplan-calendar-view',
      component: MassnahmenCalendarView
    },
    {
      path: '/blank-page',
      name: 'blank-page',
      component: Blankpage
    },
    {
      path: '/mandant',
      name: 'auswertungen',
      component: Companies
    },
    {
      path: '/components',
      name: 'components',
      component: Components
    },
    {
      path: '/vt',
      name: 'vt',
      component: VTs
    },
    {
      path: '/vt-selbst',
      name: 'vt-selbst',
      component: VTSelbst
    },
    {
      path: '/systeme',
      name: 'systeme',
      component: System
    },
    {
      path: '/systeme-assess',
      name: 'systeme-assess',
      component: SystemAssessmentList
    },
    {
      path: '/dienstleister',
      name: 'dienstleister',
      component: Supplier
    },
    {
      path: '/risiko',
      name: 'Risiko',
      component: Deals
    },
    {
      path: '/panne',
      name: 'panne',
      component: Email
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: Error404
    },
    {
      path: '/error-500',
      name: 'error-500',
      component: Error500
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/form-basic-inputs',
      name: 'form-basic-inputs',
      component: FormBasicInputs
    },
    {
      path: '/form-horizontal',
      name: 'form-horizontal',
      component: FormHorizontal
    },
    {
      path: '/form-input-groups',
      name: 'form-input-groups',
      component: FormInputGroups
    },
    {
      path: '/form-mask',
      name: 'form-mask',
      component: FormMask
    },
    {
      path: '/form-validation',
      name: 'form-validation',
      component: FormValidation
    },
    {
      path: '/form-vertical',
      name: 'form-vertical',
      component: FormVertical
    },
    {
      path: '/gap-list',
      name: 'gap-list',
      component: GapList
    },
    {
      path: '/ai-gap-list',
      name: 'ai-gap-list',
      component: AIGapList
    },
    {
      path: '/gap-survey',
      name: 'gap-survey',
      component: TestGap
    },
    {
      path: '/gap-edit',
      name: 'gap-edit',
      component: EditGap
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/mail-view',
      name: 'mail-view',
      component: MailView
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/projects-kanban-view',
      name: 'projects-kanban-view',
      component: ProjectsKanbanView
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/tables-basic',
      name: 'tables-basic',
      component: TablesBasic
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: Tasks
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms
    },
    {
      path: '/projects-dashboard',
      name: 'projects-dashboard',
      component: ProjectsDashboard
    },
    {
      path: '/survey-sample',
      name: 'survey-sample',
      component: Survey
    },
    {
      path: '/toms-list',
      name: 'toms-list',
      component: TomsList
    },
    {
      path: '/toms',
      name: 'toms',
      component: TomsContent,
      props: true
    },
    {
      path: '/confirmtoms',
      name: 'confirmtoms',
      component: ConfirmToms
    },
    {
      path: '/toms-edit',
      name: 'toms-edit',
      component: TomsEdit
    },
    {
      path: '/avv',
      name: 'avv',
      component: CustomerInfo
    },
    {
      path: '/avv-demo',
      name: 'avv-demo',
      component: CustomerInfoDemo
    },
    {
      path: '/avv-content',
      name: 'avv-content',
      component: SurveyContent,
      hidden: true,
      props: true
    },
    {
      path: '/avv-edit',
      name: 'avv-edit',
      component: AvvEdit
    },
    {
      path: '/avv-list',
      name: 'avv-list',
      component: AvvList
    },
    {
      path: '/avv-preview',
      name: 'avv-preview',
      component: SurveyPreview
    },
    {
      path: '/avv-confirm',
      name: 'avv-confirm',
      component: ConfirmAV,
      hidden: true,
      props: true
    },
    {
      path: '/incident',
      name: 'incident',
      component: Incident,
    },
    {
      path: '/audit',
      name: 'audit',
      component: Audit,
    },
    {
      path: '/audit-plan',
      name: 'audit-plan',
      component: AuditPlan,
    },
    {
      path: '/shared-responsibilty',
      name: 'shared-responsibilty',
      component: SharedResponsibility,
    },
    {
      path: '/goto',
      name: 'goto',
      component: Goto,
    },
    {
      path: '/generate-ds-report',
      name: 'generate-ds-report',
      component: GenerateDSReport,
    },
    {
      path: '/risk-analysis',
      name: 'risk-analysis',
      component: RiskAnalysis,
    },
    {
      path: '/translator',
      name: 'translator',
      component: ChatBot,
    },
    {
      path: '/ai-chat',
      name: 'ai-chat',
      component: AIChatBot,
    },
    {
      path: '/create-website-audit',
      name: 'create-website-audit',
      component: CreateWebsiteAudit,
    },
    {
      path: '/website-audits',
      name: 'website-audits',
      component: WebsiteAudit,
    },
  ],
  linkActiveClass: "active",
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'index' && to.name != 'goto' && !store.getters.authenticated) next({ name: 'index' })
  else next()
})
export default router
